module.exports = __webpack_public_path__ + "img/8_ward_800.3c0058e0.png";